import { ReduxConstants } from "utils/constants";
import { ListActionType } from "models/actionTypes/listActionTypes";
import { ListState } from "models/stateTypes/listState";

export const setListNavigation = (state: ListState): ListActionType => {
  return {
    type: ReduxConstants.ListActions.SET_LIST_NAVIGATION,
    payload: state,
  };
};

export const loadItems = (items: (string | number)[], total: number): ListActionType => {
  return {
    type: ReduxConstants.ListActions.LOAD_ITEMS,
    payload: { items: items, total: total },
  };
};

export const setCurrentIndex = (index: number, page: number): ListActionType => {
  return {
    type: ReduxConstants.ListActions.SET_CURRENT_INDEX,
    payload: { index: index, page: page },
  };
};
